import { pick } from 'ramda';

import { AppConfigFormat, UseAppRemoteStateState, UseAppRemoteStateUpdateReason } from './useAppRemoteState.types';

export const pickPersistableState = pick<(keyof AppConfigFormat)[]>(['navDrawerPinned']);

export const getInitialState = (): UseAppRemoteStateState => ({
  data: {
    navDrawerPinned: true,
  },
  updateReason: UseAppRemoteStateUpdateReason.INITIAL,
  loading: true,
});
